import initializeComponent from '../react-initialize';
import Header from './header';
import { initializeNotificationsService } from '../Notifications/notification_service';
import { withBreakpointsContext } from 'core-components';

initializeNotificationsService();

initializeComponent('Header', withBreakpointsContext(Header));
